
export default [
    {
        path: '/groups',
        redirect: { name: 'group-list' },
        name: 'groups',
        component: () => import(/*webpackChunkName: "GroupsView"*/'@/modules/groups/views/Groups'),
        meta: {
            requiresAuth: true,
            // permissions: ['groups_menu_show_group']
        },
        children: [
            // UserHome will be rendered inside User's <router-view>
            // when /fives-club/housing is matched
            { path: '', name: 'group-list', component: () => import(/*webpackChunkName: 'ListRooms'*/'@/modules/groups/views/ListRooms'), },
            { path: 'view/:id', name: 'view-group', component: () => import(/*webpackChunkName: 'GroupView'*/'@/modules/groups/views/GroupView'), },
        ]
    }
]